import React, { useState, useEffect } from "react";
import api from "../services/api";
import { formatearFecha } from "../utils/dateUtils";

const Reportes = () => {
  const [tipoReporte, setTipoReporte] = useState("valorizado");
  const [categoriaReporte, setCategoriaReporte] = useState("general");
  const [materiales, setMateriales] = useState([]);
  const [materialSeleccionado, setMaterialSeleccionado] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [tipoMovimiento, setTipoMovimiento] = useState("todos");
  const [datosReporte, setDatosReporte] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [mensaje, setMensaje] = useState({ texto: "", tipo: "" });
  const [almacenes, setAlmacenes] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [almacenSeleccionado, setAlmacenSeleccionado] = useState("");
  const [proyectoSeleccionado, setProyectoSeleccionado] = useState("");

  useEffect(() => {
    obtenerMateriales();
    obtenerAlmacenes();
    obtenerProyectos();
  }, []);

  const obtenerMateriales = async () => {
    try {
      const res = await api.get("/materiales");
      setMateriales(res.data);
    } catch (error) {
      console.error("Error al cargar materiales:", error);
    }
  };

 const obtenerAlmacenes = async () => {
    try {
      const res = await api.get("/almacenes");
      // Forzamos que sea un array buscando en res.data o res.data.data
      const dataArray = Array.isArray(res.data) ? res.data : (res.data.data || res.data.todos || []);
      setAlmacenes(dataArray);
    } catch (error) {
      console.error("Error al cargar almacenes:", error);
      setAlmacenes([]); // Evita que el .map falle en caso de error
    }
  };

 const obtenerProyectos = async () => {
    try {
      const res = await api.get("/proyectos");
      // Forzamos que sea un array
      const dataArray = Array.isArray(res.data) ? res.data : (res.data.data || res.data.proyectos || []);
      setProyectos(dataArray);
    } catch (error) {
      console.error("Error al cargar proyectos:", error);
      setProyectos([]); // Evita que el .map falle en caso de error
    }
  };

  const cambiarCategoria = (categoria) => {
    setCategoriaReporte(categoria);
    setDatosReporte(null);
    
    // Cambiar el tipo de reporte por defecto según la categoría
    if (categoria === "general") {
      setTipoReporte("valorizado");
    } else {
      setTipoReporte("stock-almacen");
    }
  };

  const generarReporte = async () => {
    if (tipoReporte === "kardex" && !materialSeleccionado) {
      setMensaje({ texto: "⚠️ Debes seleccionar un material para el Kardex", tipo: "error" });
      return;
    }
    if (tipoReporte === "stock-almacen" && !almacenSeleccionado) {
      setMensaje({ texto: "⚠️ Debes seleccionar un almacén", tipo: "error" });
      return;
    }
    if (tipoReporte === "consumo-proyecto" && !proyectoSeleccionado) {
      setMensaje({ texto: "⚠️ Debes seleccionar un proyecto", tipo: "error" });
      return;
    }
    if (tipoReporte === "consumo-total-proyecto" && !proyectoSeleccionado) {
    setMensaje({ texto: "⚠️ Selecciona un proyecto para el reporte financiero", tipo: "error" });
    return;
  }



    try {
      setCargando(true);
      setMensaje({ texto: "", tipo: "" });
      let res;

      switch (tipoReporte) {
        case "kardex":
          res = await api.get(`/reportes/kardex/${materialSeleccionado}`, {
            params: { fechaInicio, fechaFin },
          });
          break;

        case "valorizado":
          res = await api.get("/reportes/valorizado");
          break;

        case "movimientos":
          res = await api.get("/reportes/movimientos", {
            params: { fechaInicio, fechaFin, tipo: tipoMovimiento },
          });
          break;

        case "auditoria":
          res = await api.get("/reportes/auditoria");
          break;

        case "consumo-destino":
          res = await api.get("/reportes/consumo-por-destino");
          break;

        case "por-categoria":
          res = await api.get("/reportes/por-categoria");
          break;

        case "stock-almacen":
          res = await api.get(`/reportes/stock-almacen/${almacenSeleccionado}`);
          break;

        case "consumo-proyecto":
          res = await api.get(`/reportes/consumo-proyecto/${proyectoSeleccionado}`);
          break;

        case "prestamos-pendientes":
          res = await api.get("/reportes/prestamos-pendientes");
          break;

         case "consumo-total-proyecto":
         res = await api.get(`/reportes/consumo-total/${proyectoSeleccionado}`);
         break;

         case "reporte-global-proyectos":
         res = await api.get("/reportes/reporte-global-proyectos");
         break;

        default:
          throw new Error("Tipo de reporte no válido");
      }

      console.log("Datos recibidos del backend:", res.data);
      setDatosReporte(res.data);
      setMensaje({ texto: "✅ Reporte generado exitosamente", tipo: "success" });
    } catch (error) {
      console.error("Error al generar reporte:", error);
      setMensaje({ texto: "❌ Error al generar el reporte", tipo: "error" });
    } finally {
      setCargando(false);
    }
  };

  const exportarExcel = async () => {
    if (!datosReporte) return;

    // Validaciones específicas
    if (tipoReporte === "kardex" && !materialSeleccionado) return;
    if (tipoReporte === "stock-almacen" && !almacenSeleccionado) return;
    if (tipoReporte === "consumo-proyecto" && !proyectoSeleccionado) return;

    try {
      let endpoint = "";

      switch (tipoReporte) {
        case "kardex":
          endpoint = `/reportes/kardex/${materialSeleccionado}/excel`;
          break;
        case "valorizado":
          endpoint = "/reportes/valorizado/excel";
          break;
        case "movimientos":
          endpoint = "/reportes/movimientos/excel";
          break;
        case "consumo-destino":
          endpoint = "/reportes/consumo-por-destino/excel";
          break;
        case "por-categoria":
          endpoint = "/reportes/por-categoria/excel";
          break;
        case "stock-almacen":
          endpoint = `/reportes/stock-almacen/${almacenSeleccionado}/excel`;
          break;
        case "consumo-proyecto":
          endpoint = `/reportes/consumo-proyecto/${proyectoSeleccionado}/excel`;
          break;
        case "prestamos-pendientes":
          endpoint = "/reportes/prestamos-pendientes/excel";
          break;
        default:
          return;
      }

      const response = await api.get(endpoint, {
        params: tipoReporte === "movimientos" ? { fechaInicio, fechaFin, tipo: tipoMovimiento } : 
                tipoReporte === "kardex" ? { fechaInicio, fechaFin } : {},
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `reporte_${tipoReporte}_${new Date().getTime()}.xlsx`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      setMensaje({ texto: "✅ Reporte Excel descargado exitosamente", tipo: "success" });
    } catch (error) {
      console.error("Error al exportar Excel:", error);
      setMensaje({ texto: "❌ Error al exportar el reporte a Excel", tipo: "error" });
    }
  };

  const imprimirReporte = () => {
    window.print();
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>📊 Sistema de Reportes</h1>
        <p style={styles.subtitle}>Genera reportes detallados para análisis y auditoría</p>
      </div>

      {/* ═══════════════════════════════════════════════════════════════ */}
      {/* PESTAÑAS DE CATEGORÍAS */}
      {/* ═══════════════════════════════════════════════════════════════ */}
      <div style={styles.tabsContainer}>
        <button
          style={{
            ...styles.tab,
            ...(categoriaReporte === "general" ? styles.tabActive : {}),
          }}
          onClick={() => cambiarCategoria("general")}
        >
          📦 Inventario General
        </button>
        <button
          style={{
            ...styles.tab,
            ...(categoriaReporte === "construccion" ? styles.tabActive : {}),
          }}
          onClick={() => cambiarCategoria("construccion")}
        >
          🏗️ Gestión de Construcción
        </button>
      </div>

      <div style={styles.card}>
        <h3 style={styles.cardTitle}>⚙️ Configuración del Reporte</h3>

        <div style={styles.formGrid}>
          {/* ═══════════════════════════════════════════════════════════ */}
          {/* SELECT DE REPORTES SEGÚN CATEGORÍA */}
          {/* ═══════════════════════════════════════════════════════════ */}
          <div style={styles.formGroup}>
            <label style={styles.label}>📋 Tipo de Reporte</label>
            <select
              style={styles.select}
              value={tipoReporte}
              onChange={(e) => {
                setTipoReporte(e.target.value);
                setDatosReporte(null);
              }}
            >
              {categoriaReporte === "general" ? (
                // REPORTES GENERALES
                <>
                  <option value="valorizado">Reporte Valorizado de Inventario</option>
                  <option value="por-categoria">Reporte por Categoría</option>
                  <option value="kardex">Kardex por Material</option>
                  <option value="movimientos">Movimientos por Período</option>
                  <option value="auditoria">Auditoría del Sistema</option>
                  <option value="consumo-destino">Consumo por Departamento</option>
                </>
              ) : (
                // REPORTES DE CONSTRUCCIÓN
                <>
  <option value="stock-almacen">Stock por Almacén</option>
  {/* Cambio de nombre solicitado por el cliente */}
  <option value="consumo-proyecto">Consumo de Materiales en Proyecto</option> 
  {/* Nueva opción solicitada */}
  <option value="consumo-total-proyecto">Consumo Total (Financiero)</option>
  {/* El tercero: Reporte Global */}
  <option value="reporte-global-proyectos">Resumen Financiero Global</option>
  <option value="prestamos-pendientes">Préstamos Pendientes</option>
</>
              )}
            </select>
          </div>

          {/* Material (solo para Kardex) */}
          {tipoReporte === "kardex" && (
            <div style={styles.formGroup}>
              <label style={styles.label}>📦 Material</label>
              <select
                style={styles.select}
                value={materialSeleccionado}
                onChange={(e) => setMaterialSeleccionado(e.target.value)}
              >
                <option value="">-- Selecciona un material --</option>
                {materiales.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.codigo} - {m.nombre}
                  </option>
                ))}
              </select>
            </div>
          )}

          {tipoReporte === "stock-almacen" && (
            <div style={styles.formGroup}>
              <label style={styles.label}>🏪 Almacén</label>
              <select
                style={styles.select}
                value={almacenSeleccionado}
                onChange={(e) => setAlmacenSeleccionado(e.target.value)}
              >
                <option value="">-- Selecciona un almacén --</option>
                {almacenes.map((a) => (
                  <option key={a.id} value={a.id}>
                    {a.codigo} - {a.nombre}
                  </option>
                ))}
              </select>
            </div>
          )}
{/* 📍 Busca esta línea en tu Reportes.jsx */}
{(tipoReporte === "consumo-proyecto" || tipoReporte === "consumo-total-proyecto") && (
  <div style={styles.formGroup}>
    <label style={styles.label}>🏗️ Proyecto</label>
    <select
      style={styles.select}
      value={proyectoSeleccionado}
      onChange={(e) => {
        setProyectoSeleccionado(e.target.value);
        setDatosReporte(null); // Limpiamos datos viejos al cambiar proyecto
      }}
    >
      <option value="">-- Selecciona un proyecto --</option>
      {proyectos.map((p) => (
        <option key={p.id} value={p.id}>
          {p.codigo} - {p.nombre}
        </option>
      ))}
    </select>
  </div>
)}

          {/* Tipo de Movimiento (solo para Movimientos) */}
          {tipoReporte === "movimientos" && (
            <div style={styles.formGroup}>
              <label style={styles.label}>🔄 Tipo de Movimiento</label>
              <select
                style={styles.select}
                value={tipoMovimiento}
                onChange={(e) => setTipoMovimiento(e.target.value)}
              >
                <option value="todos">Todos</option>
                <option value="entrada">Solo Entradas</option>
                <option value="salida">Solo Salidas</option>
              </select>
            </div>
          )}

          {/* Fechas (para Kardex y Movimientos) */}
          {(tipoReporte === "kardex" || tipoReporte === "movimientos") && (
            <>
              <div style={styles.formGroup}>
                <label style={styles.label}>📅 Fecha Inicio</label>
                <input
                  type="date"
                  style={styles.input}
                  value={fechaInicio}
                  onChange={(e) => setFechaInicio(e.target.value)}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>📅 Fecha Fin</label>
                <input
                  type="date"
                  style={styles.input}
                  value={fechaFin}
                  onChange={(e) => setFechaFin(e.target.value)}
                />
              </div>
            </>
          )}
        </div>

        <div style={styles.actions}>
          <button
            style={styles.btnGenerar}
            onClick={generarReporte}
            disabled={cargando}
          >
            {cargando ? "⏳ Generando..." : "📊 Generar Reporte"}
          </button>

          {datosReporte && (
            <>
              <button style={styles.btnExcel} onClick={exportarExcel}>
                📥 Exportar a Excel
              </button>
              <button style={styles.btnImprimir} onClick={imprimirReporte}>
                🖨️ Imprimir
              </button>
            </>
          )}
        </div>

        {mensaje.texto && (
          <div style={mensaje.tipo === "success" ? styles.mensajeExito : styles.mensajeError}>
            {mensaje.texto}
          </div>
        )}
      </div>

      {/* Resultados del Reporte */}
      {datosReporte && (
        <div id="printArea" style={styles.resultados}>
          {/* KARDEX */}
          {tipoReporte === "kardex" && (
            <div style={styles.card}>
              <div style={styles.reportHeader}>
                {/* Encabezado con logo integrado */}
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '20px',
                  paddingBottom: '15px',
                  borderBottom: '2px solid #e2e8f0'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <div style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      backgroundColor: "#f1f5f9",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "hidden",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      flexShrink: 0
                    }}>
                      <img 
                        src="/digera.png" 
                        alt="DIGERA" 
                        style={{ width: "85%", height: "85%", objectFit: "contain" }}
                      />
                    </div>
                    <div>
                      <h2 style={{
                        fontSize: '22px',
                        fontWeight: '700',
                        color: '#1e293b',
                        margin: '0 0 5px 0'
                      }}>KARDEX DE MATERIAL</h2>
                      <p style={{
                        margin: '0',
                        fontSize: '12px',
                        color: '#64748b'
                      }}>Inventario Pro - Sistema de Gestión</p>
                    </div>
                  </div>
                </div>

                <div style={styles.reportInfo}>
                  <p><strong>Código:</strong> {datosReporte.material.codigo}</p>
                  <p><strong>Nombre:</strong> {datosReporte.material.nombre}</p>
                  <p><strong>Unidad:</strong> {datosReporte.material.unidad}</p>
                  <p><strong>Categoría:</strong> {datosReporte.material.categoria}</p>
                  <p><strong>Período:</strong> {datosReporte.periodo.inicio} - {datosReporte.periodo.fin}</p>
                </div>
              </div>

              <div style={styles.tableContainer}>
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHeader}>
                      <th style={styles.th}>Fecha</th>
                      <th style={styles.th}>Tipo</th>
                      <th style={styles.th}>Documento</th>
                      <th style={styles.th} colSpan="3">ENTRADAS</th>
                      <th style={styles.th} colSpan="3">SALIDAS</th>
                      <th style={styles.th} colSpan="3">SALDO</th>
                    </tr>
                    <tr style={styles.tableSubHeader}>
                      <th style={styles.th}></th>
                      <th style={styles.th}></th>
                      <th style={styles.th}></th>
                      <th style={styles.thSmall}>Cant</th>
                      <th style={styles.thSmall}>Costo</th>
                      <th style={styles.thSmall}>Valor</th>
                      <th style={styles.thSmall}>Cant</th>
                      <th style={styles.thSmall}>Costo</th>
                      <th style={styles.thSmall}>Valor</th>
                      <th style={styles.thSmall}>Cant</th>
                      <th style={styles.thSmall}>Costo</th>
                      <th style={styles.thSmall}>Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {datosReporte.movimientos.map((mov, idx) => (
                      <tr key={idx} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                       <td>{formatearFecha(mov.fecha)}</td>
                        <td style={styles.td}>
                          <span style={mov.tipo === 'ENTRADA' ? styles.badgeEntrada : styles.badgeSalida}>
                            {mov.tipo}
                          </span>
                        </td>
                        <td style={styles.td}>{mov.documento}</td>
                        <td style={styles.tdNum}>{mov.entrada_cantidad || '-'}</td>
                        <td style={styles.tdNum}>{mov.entrada_costo ? `RD$ ${parseFloat(mov.entrada_costo).toFixed(2)}` : '-'}</td>
                        <td style={styles.tdNum}>{mov.entrada_valor ? `RD$ ${parseFloat(mov.entrada_valor).toFixed(2)}` : '-'}</td>
                        <td style={styles.tdNum}>{mov.salida_cantidad || '-'}</td>
                        <td style={styles.tdNum}>{mov.salida_costo ? `RD$ ${parseFloat(mov.salida_costo).toFixed(2)}` : '-'}</td>
                        <td style={styles.tdNum}>{mov.salida_valor ? `RD$ ${parseFloat(mov.salida_valor).toFixed(2)}` : '-'}</td>
                        <td style={styles.tdNum}><strong>{mov.saldo_cantidad}</strong></td>
                        <td style={styles.tdNum}><strong>RD$ {parseFloat(mov.saldo_costo || 0).toFixed(2)}</strong></td>
                        <td style={styles.tdNum}><strong>RD$ {parseFloat(mov.saldo_valor || 0).toFixed(2)}</strong></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div style={styles.resumenBox}>
                <h4>📊 Resumen</h4>
                <p><strong>Total Entradas:</strong> {datosReporte.resumen.total_entradas}</p>
                <p><strong>Total Salidas:</strong> {datosReporte.resumen.total_salidas}</p>
                <p><strong>Saldo Final:</strong> {datosReporte.resumen.saldo_final_cantidad} unidades</p>
                <p><strong>Valor Final:</strong> RD$ {parseFloat(datosReporte.resumen.saldo_final_valor || 0).toFixed(2)}</p>
              </div>
            </div>
          )}

          {/* VALORIZADO */}
          {tipoReporte === "valorizado" && datosReporte && (
            <div style={styles.card}>
              {/* Encabezado con logo integrado */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '20px',
                paddingBottom: '15px',
                borderBottom: '2px solid #e2e8f0'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <div style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    backgroundColor: "#f1f5f9",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    flexShrink: 0
                  }}>
                    <img 
                      src="/digera.png" 
                      alt="DIGERA" 
                      style={{ width: "85%", height: "85%", objectFit: "contain" }}
                    />
                  </div>
                  <div>
                    <h2 style={{
                      fontSize: '22px',
                      fontWeight: '700',
                      color: '#1e293b',
                      margin: '0 0 5px 0'
                    }}>REPORTE VALORIZADO DE INVENTARIO</h2>
                    <p style={{
                      margin: '0',
                      fontSize: '12px',
                      color: '#64748b'
                    }}>Inventario Pro - Sistema de Gestión</p>
                  </div>
                </div>
              </div>
              
              {/* Verificar si datosReporte tiene la estructura correcta */}
              {datosReporte.resumen ? (
                <>
                  <div style={styles.statsGrid}>
                    <div style={styles.statCard}>
                      <div style={styles.statValue}>{datosReporte.resumen.total_materiales || 0}</div>
                      <div style={styles.statLabel}>Total Materiales</div>
                    </div>
                    <div style={styles.statCard}>
                      <div style={styles.statValue}>{datosReporte.resumen.total_categorias || 0}</div>
                      <div style={styles.statLabel}>Categorías</div>
                    </div>
                    <div style={{...styles.statCard, ...styles.statCardDestacado}}>
                      <div style={styles.statValue}>RD$ {parseFloat(datosReporte.resumen.valor_total_inventario || 0).toLocaleString()}</div>
                      <div style={styles.statLabel}>Valor Total Inventario</div>
                    </div>
                    <div style={{...styles.statCard, backgroundColor: '#fee2e2'}}>
                      <div style={{...styles.statValue, color: '#dc2626'}}>{datosReporte.resumen.materiales_criticos || 0}</div>
                      <div style={styles.statLabel}>Materiales Críticos</div>
                    </div>
                  </div>

                  <div style={styles.tableContainer}>
                    <table style={styles.table}>
                      <thead>
                        <tr style={styles.tableHeader}>
                          <th style={styles.th}>Código</th>
                          <th style={styles.th}>Nombre</th>
                          <th style={styles.th}>Categoría</th>
                          <th style={styles.th}>Unidad</th>
                          <th style={styles.th}>Stock Actual</th>
                          <th style={styles.th}>Stock Mínimo</th>
                          <th style={styles.th}>Costo Prom.</th>
                          <th style={styles.th}>Valor Actual</th>
                          <th style={styles.th}>Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(datosReporte.detalle_completo || datosReporte.materiales || []).map((item, idx) => (
                          <tr key={idx} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                            <td style={styles.td}><strong>{item.codigo}</strong></td>
                            <td style={styles.td}>{item.nombre}</td>
                            <td style={styles.td}>{item.categoria}</td>
                            <td style={styles.td}>{item.unidad}</td>
                            <td style={styles.tdNum}>{item.stock_actual}</td>
                            <td style={styles.tdNum}>{item.stock_minimo}</td>
                            <td style={styles.tdNum}>RD$ {parseFloat(item.costo_promedio || 0).toFixed(2)}</td>
                            <td style={styles.tdNum}><strong>RD$ {parseFloat(item.valor_actual || 0).toFixed(2)}</strong></td>
                            <td style={styles.td}>
                              <span style={item.estado === 'CRÍTICO' ? styles.badgeCritico : styles.badgeNormal}>
                                {item.estado}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              ) : (
                <div style={{textAlign: 'center', padding: '40px', color: '#64748b'}}>
                  <p>No hay datos disponibles para mostrar</p>
                  <p style={{fontSize: '12px', marginTop: '10px'}}>
                    Estructura de datos recibida: {JSON.stringify(Object.keys(datosReporte || {}))}
                  </p>
                </div>
              )}
            </div>
          )}

          {/* MOVIMIENTOS */}
          {tipoReporte === "movimientos" && (
            <div style={styles.card}>
              {/* Encabezado con logo integrado */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '20px',
                paddingBottom: '15px',
                borderBottom: '2px solid #e2e8f0'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <div style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    backgroundColor: "#f1f5f9",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    flexShrink: 0
                  }}>
                    <img 
                      src="/digera.png" 
                      alt="DIGERA" 
                      style={{ width: "85%", height: "85%", objectFit: "contain" }}
                    />
                  </div>
                  <div>
                    <h2 style={{
                      fontSize: '22px',
                      fontWeight: '700',
                      color: '#1e293b',
                      margin: '0 0 5px 0'
                    }}>REPORTE DE MOVIMIENTOS</h2>
                    <p style={{
                      margin: '0',
                      fontSize: '12px',
                      color: '#64748b'
                    }}>Período: {datosReporte.periodo.inicio} - {datosReporte.periodo.fin}</p>
                  </div>
                </div>
              </div>

              <div style={styles.statsGrid}>
                <div style={styles.statCard}>
                  <div style={styles.statValue}>{datosReporte.resumen.total_movimientos}</div>
                  <div style={styles.statLabel}>Total Movimientos</div>
                </div>
                <div style={{ ...styles.statCard, backgroundColor: '#d1fae5' }}>
                  <div style={styles.statValue}>
                    RD$ {parseFloat(datosReporte.resumen.valor_entradas || 0).toLocaleString()}
                  </div>
                  <div style={styles.statLabel}>Entradas</div>
                </div>

                <div style={{ ...styles.statCard, backgroundColor: '#fee2e2' }}>
                  <div style={styles.statValue}>
                    RD$ {Math.abs(parseFloat(datosReporte.resumen.valor_salidas || 0)).toLocaleString()}
                  </div>
                  <div style={styles.statLabel}>Salidas</div>
                </div>

                <div style={styles.statCard}>
                  <div style={styles.statValue}>
                    RD$ {(
                      parseFloat(datosReporte.resumen.valor_entradas || 0) -
                      Math.abs(parseFloat(datosReporte.resumen.valor_salidas || 0))
                    ).toLocaleString()}
                  </div>
                  <div style={styles.statLabel}>Balance Neto</div>
                </div>
              </div>

              <div style={styles.tableContainer}>
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHeader}>
                      <th style={styles.th}>Fecha</th>
                      <th style={styles.th}>Tipo</th>
                      <th style={styles.th}>Material</th>
                      <th style={styles.th}>Cantidad</th>
                      <th style={styles.th}>Costo Unit.</th>
                      <th style={styles.th}>Valor Total</th>
                      <th style={styles.th}>Documento/Destino</th>
                    </tr>
                  </thead>
                  <tbody>
                    {datosReporte.movimientos.map((mov, idx) => (
                      <tr key={idx} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                      <td>{formatearFecha(mov.fecha)}</td>
                        <td style={styles.td}>
                          <span style={mov.tipo === 'ENTRADA' ? styles.badgeEntrada : styles.badgeSalida}>
                            {mov.tipo}
                          </span>
                        </td>
                        <td style={styles.td}>{mov.material_nombre}</td>
                        <td style={styles.tdNum}>{mov.cantidad}</td>
                        <td style={styles.tdNum}>RD$ {mov.costo_unitario.toFixed(2)}</td>
                        <td style={styles.tdNum}><strong>RD$ {mov.valor_total.toFixed(2)}</strong></td>
                        <td style={styles.td}>{mov.referencia || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* AUDITORÍA */}
          {tipoReporte === "auditoria" && datosReporte && (
            <div style={styles.card}>
              {/* Encabezado con logo integrado */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '20px',
                paddingBottom: '15px',
                borderBottom: '2px solid #e2e8f0'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <div style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    backgroundColor: "#f1f5f9",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    flexShrink: 0
                  }}>
                    <img 
                      src="/digera.png" 
                      alt="DIGERA" 
                      style={{ width: "85%", height: "85%", objectFit: "contain" }}
                    />
                  </div>
                  <div>
                    <h2 style={{
                      fontSize: '22px',
                      fontWeight: '700',
                      color: '#1e293b',
                      margin: '0 0 5px 0'
                    }}>REPORTE DE AUDITORÍA</h2>
                    <p style={{
                      margin: '0',
                      fontSize: '12px',
                      color: '#64748b'
                    }}>Fecha: {new Date(datosReporte.fecha_auditoria || new Date()).toLocaleString()}</p>
                  </div>
                </div>
              </div>

              {datosReporte.resumen ? (
                <>
                  <div style={styles.statsGrid}>
                    <div style={styles.statCard}>
                      <div style={styles.statValue}>{datosReporte.resumen.total_alertas || 0}</div>
                      <div style={styles.statLabel}>Total Alertas</div>
                    </div>
                    <div style={{...styles.statCard, backgroundColor: '#fee2e2'}}>
                      <div style={{...styles.statValue, color: '#dc2626'}}>{datosReporte.resumen.nivel_critico || 0}</div>
                      <div style={styles.statLabel}>Nivel Crítico</div>
                    </div>
                    <div style={{...styles.statCard, backgroundColor: '#fef3c7'}}>
                      <div style={{...styles.statValue, color: '#92400e'}}>{datosReporte.resumen.nivel_advertencia || 0}</div>
                      <div style={styles.statLabel}>Advertencias</div>
                    </div>
                  </div>

                  {/* Alertas */}
                  {datosReporte.alertas && datosReporte.alertas.length > 0 && (
                    <div style={styles.alertasContainer}>
                      <h3 style={styles.sectionTitle}>⚠️ Alertas Detectadas</h3>
                      {datosReporte.alertas.map((alerta, idx) => (
                        <div 
                          key={idx} 
                          style={{
                            ...styles.alertaCard,
                            borderLeft: alerta.nivel === 'CRÍTICO' ? '4px solid #dc2626' : '4px solid #f59e0b'
                          }}
                        >
                          <div style={styles.alertaHeader}>
                            <span style={alerta.nivel === 'CRÍTICO' ? styles.badgeCritico : styles.badgeAdvertencia}>
                              {alerta.nivel}
                            </span>
                            <span style={styles.alertaTipo}>{alerta.tipo}</span>
                          </div>
                          <p style={styles.alertaDescripcion}>{alerta.descripcion}</p>
                          <p style={styles.alertaCantidad}><strong>Cantidad:</strong> {alerta.cantidad} registros</p>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Detalles */}
                  {datosReporte.detalles && datosReporte.detalles.materiales_criticos && datosReporte.detalles.materiales_criticos.length > 0 && (
                    <div style={styles.detalleSection}>
                      <h3 style={styles.sectionTitle}>🚨 Materiales con Stock Crítico</h3>
                      <div style={styles.tableContainer}>
                        <table style={styles.table}>
                          <thead>
                            <tr style={styles.tableHeader}>
                              <th style={styles.th}>Código</th>
                              <th style={styles.th}>Nombre</th>
                              <th style={styles.th}>Stock Actual</th>
                              <th style={styles.th}>Stock Mínimo</th>
                              <th style={styles.th}>Diferencia</th>
                            </tr>
                          </thead>
                          <tbody>
                            {datosReporte.detalles.materiales_criticos.map((m, idx) => (
                              <tr key={idx} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                                <td style={styles.td}><strong>{m.codigo}</strong></td>
                                <td style={styles.td}>{m.nombre}</td>
                                <td style={styles.tdNum}><span style={{color: '#dc2626', fontWeight: 'bold'}}>{m.stock_actual}</span></td>
                                <td style={styles.tdNum}>{m.stock_minimo}</td>
                                <td style={styles.tdNum}><span style={{color: '#dc2626'}}>{m.diferencia}</span></td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div style={{textAlign: 'center', padding: '40px', color: '#64748b'}}>
                  <p>No hay datos de auditoría disponibles</p>
                  <p style={{fontSize: '12px', marginTop: '10px'}}>
                    Estructura de datos recibida: {JSON.stringify(Object.keys(datosReporte || {}))}
                  </p>
                </div>
              )}
            </div>
          )}

          {/* CONSUMO POR DEPARTAMENTO */}
          {tipoReporte === "consumo-destino" && datosReporte && (
            <div style={styles.card}>
              {/* Encabezado con logo integrado */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '20px',
                paddingBottom: '15px',
                borderBottom: '2px solid #e2e8f0'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <div style={{
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    backgroundColor: "#f1f5f9",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    overflow: "hidden",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    flexShrink: 0
                  }}>
                    <img 
                      src="/digera.png" 
                      alt="DIGERA" 
                      style={{ width: "85%", height: "85%", objectFit: "contain" }}
                    />
                  </div>
                  <div>
                    <h2 style={{
                      fontSize: '22px',
                      fontWeight: '700',
                      color: '#1e293b',
                      margin: '0 0 5px 0'
                    }}>REPORTE DE CONSUMO POR DEPARTAMENTO</h2>
                    <p style={{
                      margin: '0',
                      fontSize: '12px',
                      color: '#64748b'
                    }}>Inventario Pro - Sistema de Gestión</p>
                  </div>
                </div>
              </div>

              {/* Aquí debe continuar el contenido para consumo-destino */}
              <div style={styles.tableContainer}>
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHeader}>
                      <th style={styles.th}>Departamento</th>
                      <th style={styles.th}>Material</th>
                      <th style={styles.th}>Cantidad</th>
                      <th style={styles.th}>Valor Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {datosReporte.detalle && datosReporte.detalle.map((item, idx) => (
                      <tr key={idx} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                        <td style={styles.td}>{item.departamento || "N/A"}</td>
                        <td style={styles.td}>{item.material_nombre || "N/A"}</td>
                        <td style={styles.tdNum}>{item.cantidad || 0}</td>
                        <td style={styles.tdNum}>RD$ {parseFloat(item.valor_total || 0).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* STOCK POR ALMACÉN */}
          {tipoReporte === "stock-almacen" && (
            <div style={styles.card}>
              <div style={styles.reportHeader}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '20px',
                  paddingBottom: '15px',
                  borderBottom: '2px solid #e2e8f0'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <div style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      backgroundColor: "#f1f5f9",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "hidden",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      flexShrink: 0
                    }}>
                      <img 
                        src="/digera.png" 
                        alt="DIGERA" 
                        style={{ width: "85%", height: "85%", objectFit: "contain" }}
                      />
                    </div>
                    <div>
                      <h2 style={{
                        fontSize: '22px',
                        fontWeight: '700',
                        color: '#1e293b',
                        margin: '0 0 5px 0'
                      }}>STOCK DEL ALMACÉN: {datosReporte.almacen.nombre}</h2>
                      <p style={{
                        margin: '0',
                        fontSize: '12px',
                        color: '#64748b'
                      }}>Inventario Pro - Sistema de Gestión</p>
                    </div>
                  </div>
                </div>

                <div style={styles.reportInfo}>
                  <p><strong>Código:</strong> {datosReporte.almacen.codigo}</p>
                  <p><strong>Tipo:</strong> {datosReporte.almacen.tipo}</p>
                  <p><strong>Ubicación:</strong> {datosReporte.almacen.ubicacion || "N/A"}</p>
                </div>
              </div>

              {/* Resumen */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '15px',
                marginBottom: '25px'
              }}>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>
                    Total Materiales
                  </div>
                  <div style={{ fontSize: '1.5rem', color: '#1e293b', fontWeight: '700' }}>
                    {datosReporte.resumen.total_materiales}
                  </div>
                </div>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>
                    Cantidad Total
                  </div>
                  <div style={{ fontSize: '1.5rem', color: '#1e293b', fontWeight: '700' }}>
                    {parseFloat(datosReporte.resumen.total_cantidad).toLocaleString("es-DO")}
                  </div>
                </div>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>
                    Valor Total
                  </div>
                  <div style={{ fontSize: '1.5rem', color: '#1e293b', fontWeight: '700' }}>
                    RD$ {parseFloat(datosReporte.resumen.valor_total).toLocaleString("es-DO", { minimumFractionDigits: 2 })}
                  </div>
                </div>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>
                    Categorías
                  </div>
                  <div style={{ fontSize: '1.5rem', color: '#1e293b', fontWeight: '700' }}>
                    {datosReporte.resumen.total_categorias}
                  </div>
                </div>
              </div>

              {/* Tabla de stock */}
              <div style={styles.tableContainer}>
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHeader}>
                      <th style={styles.th}>Código</th>
                      <th style={styles.th}>Material</th>
                      <th style={styles.th}>Categoría</th>
                      <th style={styles.th}>Unidad</th>
                      <th style={styles.th}>Cantidad</th>
                      <th style={styles.th}>Costo Unit.</th>
                      <th style={styles.th}>Valor Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {datosReporte.detalle_completo.map((item, idx) => (
                      <tr key={idx} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                        <td style={styles.td}>{item.codigo}</td>
                        <td style={styles.td}>{item.nombre}</td>
                        <td style={styles.td}>{item.categoria || "Sin categoría"}</td>
                        <td style={styles.td}>{item.unidad}</td>
                        <td style={styles.tdNum}>{parseFloat(item.cantidad_disponible).toLocaleString("es-DO")}</td>
                        <td style={styles.tdNum}>RD$ {parseFloat(item.costo_unitario).toLocaleString("es-DO", { minimumFractionDigits: 2 })}</td>
                        <td style={styles.tdNum}>RD$ {parseFloat(item.valor_total).toLocaleString("es-DO", { minimumFractionDigits: 2 })}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* POR CATEGORÍA */}
          {tipoReporte === "por-categoria" && (
            <div style={styles.card}>
              <div style={styles.reportHeader}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '20px',
                  paddingBottom: '15px',
                  borderBottom: '2px solid #e2e8f0'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <div style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      backgroundColor: "#f1f5f9",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "hidden",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      flexShrink: 0
                    }}>
                      <img 
                        src="/digera.png" 
                        alt="DIGERA" 
                        style={{ width: "85%", height: "85%", objectFit: "contain" }}
                      />
                    </div>
                    <div>
                      <h2 style={{
                        fontSize: '22px',
                        fontWeight: '700',
                        color: '#1e293b',
                        margin: '0 0 5px 0'
                      }}>REPORTE POR CATEGORÍA</h2>
                      <p style={{
                        margin: '0',
                        fontSize: '12px',
                        color: '#64748b'
                      }}>Inventario Pro - Sistema de Gestión</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Resumen */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '15px',
                marginBottom: '25px'
              }}>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>
                    Total Categorías
                  </div>
                  <div style={{ fontSize: '1.5rem', color: '#1e293b', fontWeight: '700' }}>
                    {datosReporte.resumen.total_categorias}
                  </div>
                </div>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>
                    Con Stock
                  </div>
                  <div style={{ fontSize: '1.5rem', color: '#1e293b', fontWeight: '700' }}>
                    {datosReporte.resumen.categorias_con_stock}
                  </div>
                </div>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>
                    Total Materiales
                  </div>
                  <div style={{ fontSize: '1.5rem', color: '#1e293b', fontWeight: '700' }}>
                    {datosReporte.resumen.total_materiales}
                  </div>
                </div>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>
                    Valor Total
                  </div>
                  <div style={{ fontSize: '1.5rem', color: '#1e293b', fontWeight: '700' }}>
                    RD$ {parseFloat(datosReporte.resumen.valor_total_inventario).toLocaleString("es-DO", { minimumFractionDigits: 2 })}
                  </div>
                </div>
              </div>

              {/* Tabla por categorías */}
              {datosReporte.categorias.map((cat, idx) => (
                <div key={idx} style={{
                  marginBottom: '30px',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  overflow: 'hidden'
                }}>
                  <div style={{
                    background: '#f1f5f9',
                    padding: '15px 20px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '2px solid #e5e7eb'
                  }}>
                    <h4 style={{ margin: 0 }}>{cat.categoria_nombre}</h4>
                    <div style={{ display: 'flex', gap: '20px', fontSize: '0.9rem', color: '#64748b', fontWeight: '500' }}>
                      <span>Materiales: {cat.total_materiales}</span>
                      <span>Valor: RD$ {parseFloat(cat.valor_total).toLocaleString("es-DO", { minimumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                  
                  <div style={styles.tableContainer}>
                    <table style={styles.table}>
                      <thead>
                        <tr style={styles.tableHeader}>
                          <th style={styles.th}>Código</th>
                          <th style={styles.th}>Material</th>
                          <th style={styles.th}>Unidad</th>
                          <th style={styles.th}>Stock</th>
                          <th style={styles.th}>Costo Prom.</th>
                          <th style={styles.th}>Valor Total</th>
                          <th style={styles.th}>Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {cat.materiales.map((mat, midx) => (
                          <tr key={midx} style={midx % 2 === 0 ? styles.trEven : styles.trOdd}>
                            <td style={styles.td}>{mat.codigo}</td>
                            <td style={styles.td}>{mat.nombre}</td>
                            <td style={styles.td}>{mat.unidad}</td>
                            <td style={styles.tdNum}>{mat.stock_actual}</td>
                            <td style={styles.tdNum}>RD$ {parseFloat(mat.costo_promedio).toLocaleString("es-DO", { minimumFractionDigits: 2 })}</td>
                            <td style={styles.tdNum}>RD$ {parseFloat(mat.valor_actual).toLocaleString("es-DO", { minimumFractionDigits: 2 })}</td>
                            <td style={{
                              ...styles.td,
                              color: mat.estado === "CRÍTICO" ? "#dc2626" : "#16a34a",
                              fontWeight: "bold"
                            }}>
                              {mat.estado}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* CONSUMO POR PROYECTO */}
          {tipoReporte === "consumo-proyecto" && (
            <div style={styles.card}>
              <div style={styles.reportHeader}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  marginBottom: '20px',
                  paddingBottom: '15px',
                  borderBottom: '2px solid #e2e8f0'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <div style={{
                      width: "70px",
                      height: "70px",
                      borderRadius: "50%",
                      backgroundColor: "#f1f5f9",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      overflow: "hidden",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      flexShrink: 0
                    }}>
                      <img 
                        src="/digera.png" 
                        alt="DIGERA" 
                        style={{ width: "85%", height: "85%", objectFit: "contain" }}
                      />
                    </div>
                    <div>
                      <h2 style={{
                        fontSize: '22px',
                        fontWeight: '700',
                        color: '#1e293b',
                        margin: '0 0 5px 0'
                      }}>CONSUMO DEL PROYECTO: {datosReporte.proyecto.nombre}</h2>
                      <p style={{
                        margin: '0',
                        fontSize: '12px',
                        color: '#64748b'
                      }}>Inventario Pro - Sistema de Gestión</p>
                    </div>
                  </div>
                </div>

                <div style={styles.reportInfo}>
                  <p><strong>Código:</strong> {datosReporte.proyecto.codigo}</p>
                  <p><strong>Estado:</strong> {datosReporte.proyecto.estado}</p>
                </div>
              </div>

              {/* Resumen con presupuesto */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '15px',
                marginBottom: '25px'
              }}>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>
                    Presupuesto Total
                  </div>
                  <div style={{ fontSize: '1.5rem', color: '#1e293b', fontWeight: '700' }}>
                    RD$ {parseFloat(datosReporte.resumen.presupuesto_total).toLocaleString("es-DO", { minimumFractionDigits: 2 })}
                  </div>
                </div>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>
                    Gastado
                  </div>
                  <div style={{ fontSize: '1.5rem', color: '#1e293b', fontWeight: '700' }}>
                    RD$ {parseFloat(datosReporte.resumen.valor_total_consumido).toLocaleString("es-DO", { minimumFractionDigits: 2 })}
                  </div>
                </div>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>
                    Disponible
                  </div>
                  <div style={{ fontSize: '1.5rem', color: '#1e293b', fontWeight: '700' }}>
                    RD$ {parseFloat(datosReporte.resumen.presupuesto_disponible).toLocaleString("es-DO", { minimumFractionDigits: 2 })}
                  </div>
                </div>
                <div style={{
                  background: '#f8fafc',
                  padding: '20px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', fontWeight: '600' }}>
                    % Gastado
                  </div>
                  <div style={{ fontSize: '1.5rem', color: '#1e293b', fontWeight: '700' }}>
                    {datosReporte.resumen.porcentaje_gastado}%
                  </div>
                </div>
              </div>

              {/* Tabla de consumo */}
              <div style={styles.tableContainer}>
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHeader}>
                      <th style={styles.th}>Código</th>
                      <th style={styles.th}>Material</th>
                      <th style={styles.th}>Categoría</th>
                      <th style={styles.th}>Cantidad</th>
                      <th style={styles.th}>Costo Prom.</th>
                      <th style={styles.th}>Valor Total</th>
                      <th style={styles.th}>Nº Salidas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {datosReporte.detalle_completo.map((item, idx) => (
                      <tr key={idx} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                        <td style={styles.td}>{item.codigo}</td>
                        <td style={styles.td}>{item.nombre}</td>
                        <td style={styles.td}>{item.categoria || "Sin categoría"}</td>
                        <td style={styles.tdNum}>{parseFloat(item.cantidad_total).toLocaleString("es-DO")}</td>
                        <td style={styles.tdNum}>RD$ {parseFloat(item.costo_promedio).toLocaleString("es-DO", { minimumFractionDigits: 2 })}</td>
                        <td style={styles.tdNum}>RD$ {parseFloat(item.valor_total).toLocaleString("es-DO", { minimumFractionDigits: 2 })}</td>
                        <td style={styles.tdNum}>{item.numero_salidas}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
{/* ═══════════════════════════════════════════════════════════════ */}
          {/* PRÉSTAMOS PENDIENTES */}
          {/* ═══════════════════════════════════════════════════════════════ */}
          {tipoReporte === "prestamos-pendientes" && (
            <div style={styles.card}>
              <div style={styles.reportHeader}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', paddingBottom: '15px', borderBottom: '2px solid #e2e8f0' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <div style={{ width: "70px", height: "70px", borderRadius: "50%", backgroundColor: "#f1f5f9", display: "flex", justifyContent: "center", alignItems: "center", overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.1)", flexShrink: 0 }}>
                      <img src="/digera.png" alt="DIGERA" style={{ width: "85%", height: "85%", objectFit: "contain" }} />
                    </div>
                    <div>
                      <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#1e293b', margin: '0 0 5px 0' }}>PRÉSTAMOS PENDIENTES</h2>
                      <p style={{ margin: '0', fontSize: '12px', color: '#64748b' }}>Inventario Pro - Sistema de Gestión</p>
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '25px' }}>
                <div style={styles.resumenCard}>
                  <div style={styles.resumenLabel}>Total Pendientes</div>
                  <div style={styles.resumenValue}>{datosReporte.resumen.total_prestamos_pendientes}</div>
                </div>
                <div style={styles.resumenCard}>
                  <div style={{ ...styles.resumenLabel, color: '#16a34a' }}>Recientes (≤7 días)</div>
                  <div style={{ ...styles.resumenValue, color: '#16a34a' }}>{datosReporte.resumen.recientes}</div>
                </div>
              </div>

              <div style={styles.tableContainer}>
                <table style={styles.table}>
                  <thead>
                    <tr style={styles.tableHeader}>
                      <th style={styles.th}>Código</th>
                      <th style={styles.th}>Fecha</th>
                      <th style={styles.th}>Días</th>
                      <th style={styles.th}>Proyecto Origen</th>
                      <th style={styles.th}>Proyecto Destino</th>
                      <th style={styles.th}>Material</th>
                      <th style={styles.th}>Cantidad</th>
                      <th style={styles.th}>Valor Est.</th>
                    </tr>
                  </thead>
                  <tbody>
                    {datosReporte.todos.map((item, idx) => (
                      <tr key={idx} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
                        <td style={styles.td}>{item.es_lote ? `${item.codigo} (${item.item_lote}/${item.total_items_lote})` : item.codigo}</td>
                        <td style={styles.td}>{formatearFecha(item.fecha_prestamo)}</td>
                        <td style={{ ...styles.tdNum, color: item.dias_transcurridos > 30 ? "#dc2626" : item.dias_transcurridos > 7 ? "#f59e0b" : "#16a34a", fontWeight: "bold" }}>{item.dias_transcurridos}</td>
                        <td style={styles.td}>{item.proyecto_origen}</td>
                        <td style={styles.td}>{item.proyecto_destino}</td>
                        <td style={styles.td}>{item.material_nombre}</td>
                        <td style={styles.tdNum}>{parseFloat(item.cantidad).toLocaleString("es-DO")}</td>
                        <td style={styles.tdNum}>RD$ {parseFloat(item.valor_estimado || item.valor_total || 0).toLocaleString("es-DO", { minimumFractionDigits: 2 })}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

        {tipoReporte === "consumo-total-proyecto" && datosReporte && (
  <div style={styles.card}>
    <div style={styles.reportHeader}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
        <div style={{ width: "70px", height: "70px", borderRadius: "50%", backgroundColor: "#f1f5f9", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <img src="/digera.png" alt="Logo" style={{ width: "85%", height: "85%", objectFit: "contain" }} />
        </div>
        <div>
          <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#1e293b', margin: '0' }}>REPORTE FINANCIERO: {datosReporte.proyecto.nombre}</h2>
          <p style={{ margin: '0', fontSize: '12px', color: '#64748b' }}>Consolidado Total de Inversión y Rentabilidad</p>
        </div>
      </div>
    </div>

    <div style={styles.statsGrid}>
      <div style={styles.statCard}>
        <div style={styles.statLabel}>Valor Contrato</div>
        <div style={styles.statValue}>RD$ {parseFloat(datosReporte.proyecto.valor_contrato || 0).toLocaleString()}</div>
      </div>
      <div style={styles.statCard}>
        <div style={styles.statLabel}>Gasto Total</div>
        <div style={styles.statValue}>RD$ {parseFloat(datosReporte.resumen.presupuesto_total || 0).toLocaleString()}</div>
      </div>
      <div style={{ ...styles.statCard, borderTop: '4px solid #ef4444' }}>
        <div style={styles.statLabel}>Total Invertido</div>
        <div style={{ ...styles.statValue, color: '#ef4444' }}>RD$ {parseFloat(datosReporte.resumen.total_gastado).toLocaleString()}</div>
      </div>
      <div style={{ ...styles.statCard, borderTop: '4px solid #10b981' }}>
        <div style={styles.statLabel}>Ganancia Proyectada</div>
        <div style={{ ...styles.statValue, color: '#10b981' }}>RD$ {parseFloat(datosReporte.resumen.ganancia_estimada).toLocaleString()}</div>
      </div>
    </div>

    <div style={styles.tableContainer}>
      <h3 style={styles.sectionTitle}>💸 Desglose de Gastos</h3>
      <table style={styles.table}>
        <thead>
          <tr style={styles.tableHeader}>
            <th style={styles.th}>Concepto / Categoría</th>
            <th style={{ ...styles.th, textAlign: 'right' }}>Monto (RD$)</th>
            <th style={{ ...styles.th, textAlign: 'right' }}>%</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={styles.td}>🧱 Materiales</td><td style={styles.tdNum}>RD$ {parseFloat(datosReporte.resumen.materiales).toLocaleString()}</td><td style={styles.tdNum}>{datosReporte.resumen.total_gastado > 0 ? ((datosReporte.resumen.materiales / datosReporte.resumen.total_gastado) * 100).toFixed(1) : 0}%</td></tr>
          <tr><td style={styles.td}>👷 Mano de Obra</td><td style={styles.tdNum}>RD$ {parseFloat(datosReporte.resumen.mano_obra).toLocaleString()}</td><td style={styles.tdNum}>{datosReporte.resumen.total_gastado > 0 ? ((datosReporte.resumen.mano_obra / datosReporte.resumen.total_gastado) * 100).toFixed(1) : 0}%</td></tr>
          <tr><td style={styles.td}>🔧 Subcontratistas</td><td style={styles.tdNum}>RD$ {parseFloat(datosReporte.resumen.subcontratistas).toLocaleString()}</td><td style={styles.tdNum}>{datosReporte.resumen.total_gastado > 0 ? ((datosReporte.resumen.subcontratistas / datosReporte.resumen.total_gastado) * 100).toFixed(1) : 0}%</td></tr>
          <tr><td style={styles.td}>💰 Gastos Indirectos</td><td style={styles.tdNum}>RD$ {parseFloat(datosReporte.resumen.gastos).toLocaleString()}</td><td style={styles.tdNum}>{datosReporte.resumen.total_gastado > 0 ? ((datosReporte.resumen.gastos / datosReporte.resumen.total_gastado) * 100).toFixed(1) : 0}%</td></tr>
          <tr style={{ background: '#f1f5f9', fontWeight: 'bold' }}><td style={styles.td}>TOTAL</td><td style={styles.tdNum}>RD$ {parseFloat(datosReporte.resumen.total_gastado).toLocaleString()}</td><td style={styles.tdNum}>100%</td></tr>
        </tbody>
      </table>
    </div>
  </div>
)}
{tipoReporte === "reporte-global-proyectos" && datosReporte && (
  <div style={styles.card}>
    {/* Cabecera idéntica a la imagen */}
    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '25px', borderBottom: '2px solid #f1f5f9', paddingBottom: '20px' }}>
      <div style={{ 
        width: "70px", height: "70px", borderRadius: "50%", backgroundColor: "#fff", 
        display: "flex", justifyContent: "center", alignItems: "center", border: '1px solid #e2e8f0', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' 
      }}>
        <img src="/digera.png" alt="Logo" style={{ width: "80%", height: "80%", objectFit: "contain" }} />
      </div>
      <div>
        <h2 style={{ fontSize: '22px', fontWeight: '800', color: '#1e293b', margin: '0' }}>
          REPORTE FINANCIERO GLOBAL
        </h2>
        <p style={{ margin: '0', fontSize: '12px', color: '#64748b' }}>Consolidado de Inversión y Ejecución por Proyecto</p>
      </div>
    </div>

    <div style={styles.tableContainer}>
      <table style={styles.table}>
        <thead>
          <tr style={{ ...styles.tableHeader, backgroundColor: '#1e293b', color: '#fff' }}>
            <th style={{ ...styles.th, color: '#fff' }}>Proyecto</th>
            <th style={{ ...styles.th, textAlign: 'right', color: '#fff' }}>Valor Contrato</th>
            <th style={{ ...styles.th, textAlign: 'right', color: '#fff' }}>Gasto Totales</th>
            <th style={{ ...styles.th, textAlign: 'right', color: '#fff' }}>Gasto Ejecutados</th>
            <th style={{ ...styles.th, textAlign: 'right', color: '#fff' }}>Ganancia Proyectada.</th>
            <th style={{ ...styles.th, textAlign: 'center', color: '#fff' }}>Ejecución</th>
          </tr>
        </thead>
        <tbody>
          {datosReporte.map((p, idx) => (
            <tr key={idx} style={idx % 2 === 0 ? styles.trEven : styles.trOdd}>
              <td style={styles.td}><strong>{p.nombre}</strong></td>
              <td style={styles.tdNum}>RD$ {parseFloat(p.valor_contrato || 0).toLocaleString()}</td>
              <td style={styles.tdNum}>RD$ {parseFloat(p.inversion_total || 0).toLocaleString()}</td>
              <td style={{ ...styles.tdNum, color: '#dc2626', fontWeight: '600' }}>
                RD$ {parseFloat(p.inversion_ejecutada || 0).toLocaleString()}
              </td>
              <td style={{ ...styles.tdNum, color: '#16a34a', fontWeight: '700' }}>
                RD$ {parseFloat(p.ganancia_estimada || 0).toLocaleString()}
              </td>
              <td style={{ ...styles.td, minWidth: '120px' }}>
                <div style={{ width: '100%', background: '#e2e8f0', borderRadius: '10px', height: '8px', marginBottom: '4px' }}>
                  <div style={{ 
                    width: `${Math.min(p.porcentaje_ejecucion, 100)}%`, 
                    background: p.porcentaje_ejecucion > 90 ? '#ef4444' : '#3b82f6', 
                    height: '100%', borderRadius: '10px', transition: 'width 0.5s ease'
                  }}></div>
                </div>
                <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#475569' }}>{p.porcentaje_ejecucion}%</span>
              </td>
            </tr>
          ))}

          {/* FILA DE TOTALES GENERALES */}
          <tr style={{ backgroundColor: '#f8fafc', borderTop: '2px solid #1e293b', fontWeight: '800' }}>
            <td style={{ ...styles.td, fontSize: '14px' }}>TOTAL GENERAL</td>
            <td style={{ ...styles.tdNum, fontSize: '14px' }}>
              RD$ {datosReporte.reduce((acc, p) => acc + (Number(p.valor_contrato) || 0), 0).toLocaleString()}
            </td>
            <td style={{ ...styles.tdNum, fontSize: '14px' }}>
              RD$ {datosReporte.reduce((acc, p) => acc + (Number(p.inversion_total) || 0), 0).toLocaleString()}
            </td>
            <td style={{ ...styles.tdNum, color: '#dc2626', fontSize: '14px' }}>
              RD$ {datosReporte.reduce((acc, p) => acc + (Number(p.inversion_ejecutada) || 0), 0).toLocaleString()}
            </td>
            <td style={{ ...styles.tdNum, color: '#16a34a', fontSize: '14px' }}>
              RD$ {datosReporte.reduce((acc, p) => acc + (Number(p.ganancia_estimada) || 0), 0).toLocaleString()}
            </td>
            <td style={{ ...styles.td, textAlign: 'center' }}>
              <span style={{ fontSize: '12px', background: '#1e293b', color: '#fff', padding: '2px 8px', borderRadius: '4px' }}>
                {datosReporte.length} Proyectos
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
)}
        </div> 
      )}
    </div> 
  );
};



const styles = {
  container: {
    padding: "20px",
    maxWidth: "1400px",
    margin: "0 auto",
  },
  header: {
    marginBottom: "30px",
    textAlign: "center",
  },
  title: {
    fontSize: "2.5rem",
    color: "#1e293b",
    marginBottom: "10px",
  },
  subtitle: {
    fontSize: "1.1rem",
    color: "#64748b",
  },
  // ═══════════════════════════════════════════════════════════════════════
  // ESTILOS PESTAÑAS
  // ═══════════════════════════════════════════════════════════════════════
  tabsContainer: {
    display: "flex",
    gap: "10px",
    marginBottom: "20px",
    borderBottom: "2px solid #e5e7eb",
  },
  tab: {
    padding: "12px 24px",
    border: "none",
    background: "transparent",
    color: "#64748b",
    fontSize: "1rem",
    fontWeight: "500",
    cursor: "pointer",
    borderBottom: "3px solid transparent",
    transition: "all 0.3s ease",
  },
  tabActive: {
    color: "#1e40af",
    borderBottom: "3px solid #1e40af",
    fontWeight: "600",
  },

  card: {
    background: "white",
    borderRadius: "12px",
    padding: "25px",
    marginBottom: "25px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
  cardTitle: {
    fontSize: "1.4rem",
    color: "#1e293b",
    marginBottom: "20px",
    borderBottom: "2px solid #e5e7eb",
    paddingBottom: "10px",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
    gap: "20px",
    marginBottom: "20px",
  },
  formGroup: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "0.9rem",
    fontWeight: "600",
    color: "#475569",
    marginBottom: "8px",
  },

  input: {
    padding: "10px",
    border: "2px solid #e5e7eb",
    borderRadius: "8px",
    fontSize: "1rem",
    outline: "none",
    transition: "border-color 0.3s ease",
  },
  select: {
    padding: "10px",
    border: "2px solid #e5e7eb",
    borderRadius: "8px",
    fontSize: "1rem",
    outline: "none",
    transition: "border-color 0.3s ease",
  },

  actions: {
    display: "flex",
    gap: "15px",
    flexWrap: "wrap",
  },

  btnGenerar: {
    padding: "12px 30px",
    background: "#1e40af",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
  btnExcel: {
    padding: "12px 30px",
    background: "#16a34a",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
  btnExportar: {
    padding: '12px 24px',
    background: '#10b981',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  btnImprimir: {
    padding: "12px 30px",
    background: "#64748b",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "1rem",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background 0.3s ease",
  },
  message: {
    marginTop: '20px',
    padding: '12px 20px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    textAlign: 'center',
  },
  mensajeExito: {
    padding: "15px",
    background: "#d1fae5",
    color: "#065f46",
    borderRadius: "8px",
    marginTop: "20px",
    fontWeight: "500",
  },
  mensajeError: {
    padding: "15px",
    background: "#fee2e2",
    color: "#991b1b",
    borderRadius: "8px",
    marginTop: "20px",
    fontWeight: "500",
  },
  messageInfo: {
    background: '#dbeafe',
    color: '#1e3a8a',
    border: '1px solid #3b82f6',
  },
  resultados: {
    marginTop: '30px',
  },
  reportHeader: {
    marginBottom: '25px',
    paddingBottom: '20px',
    borderBottom: '2px solid #e2e8f0',
  },
  reportTitle: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#1e293b',
    textAlign: 'center',
    marginBottom: '15px',
  },
  reportSubtitle: {
    fontSize: '14px',
    color: '#64748b',
    textAlign: 'center',
    marginBottom: '20px',
  },
  reportInfo: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '10px',
    fontSize: '13px',
    color: '#475569',
  },
  resumenGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "15px",
    marginBottom: "25px",
  },
  resumenCard: {
    background: "#f8fafc",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #e5e7eb",
  },
  resumenLabel: {
    fontSize: "0.85rem",
    color: "#64748b",
    marginBottom: "8px",
    textTransform: "uppercase",
    fontWeight: "600",
  },
  resumenValue: {
    fontSize: "1.5rem",
    color: "#1e293b",
    fontWeight: "700",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "15px",
  },
  th: {
    background: "#1e293b",
    color: "white",
    padding: "12px",
    textAlign: "left",
    fontSize: "0.9rem",
    fontWeight: "600",
  },
  td: {
    padding: "12px",
    borderBottom: "1px solid #e5e7eb",
    fontSize: "0.9rem",
    color: "#475569",
  },

  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '20px',
    marginBottom: '30px',
  },
  statCard: {
    background: '#f8fafc',
    padding: '20px',
    borderRadius: '10px',
    textAlign: 'center',
    border: '1px solid #e2e8f0',
  },
  statCardDestacado: {
    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
    color: 'white',
  },
  statValue: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '5px',
  },
  statLabel: {
    fontSize: '12px',
    color: '#64748b',
    textTransform: 'uppercase',
    fontWeight: '600',
  },
  tableContainer: {
    overflowX: 'auto',
    marginTop: '20px',
  },

  tableHeader: {
    background: '#1e293b',
    color: 'white',
  },
  tableSubHeader: {
    background: '#334155',
    color: 'white',
  },

  thSmall: {
    padding: '8px 6px',
    textAlign: 'center',
    fontWeight: '600',
    fontSize: '11px',
  },
  trEven: {
    background: '#f8fafc',
  },
  trOdd: {
    background: 'white',
  },
  categoriaSection: {
    marginBottom: "30px",
    border: "1px solid #e5e7eb",
    borderRadius: "8px",
    overflow: "hidden",
  },
  categoriaHeader: {
    background: "#f1f5f9",
    padding: "15px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "2px solid #e5e7eb",
  },
  categoriaStats: {
    display: "flex",
    gap: "20px",
    fontSize: "0.9rem",
    color: "#64748b",
    fontWeight: "500",
  },
  reporteContainer: {
    marginTop: "20px",
  },
  tdNum: {
    padding: '10px 8px',
    borderBottom: '1px solid #e2e8f0',
    color: '#475569',
    textAlign: 'right',
  },
  badgeEntrada: {
    display: 'inline-block',
    padding: '4px 12px',
    background: '#d1fae5',
    color: '#065f46',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: '600',
  },
  badgeSalida: {
    display: 'inline-block',
    padding: '4px 12px',
    background: '#fee2e2',
    color: '#991b1b',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: '600',
  },
  badgeCritico: {
    display: 'inline-block',
    padding: '4px 12px',
    background: '#fee2e2',
    color: '#991b1b',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: '700',
  },
  badgeNormal: {
    display: 'inline-block',
    padding: '4px 12px',
    background: '#d1fae5',
    color: '#065f46',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: '600',
  },
  badgeAdvertencia: {
    display: 'inline-block',
    padding: '4px 12px',
    background: '#fef3c7',
    color: '#92400e',
    borderRadius: '20px',
    fontSize: '11px',
    fontWeight: '700',
  },
  resumenBox: {
    marginTop: '30px',
    padding: '20px',
    background: '#f8fafc',
    borderRadius: '10px',
    border: '2px solid #3b82f6',
  },
  alertasContainer: {
    marginTop: '30px',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '15px',
  },
  alertaCard: {
    background: 'white',
    padding: '15px 20px',
    marginBottom: '15px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
  },
  alertaHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '10px',
  },
  alertaTipo: {
    fontSize: '12px',
    fontWeight: '600',
    color: '#64748b',
    textTransform: 'uppercase',
  },
  alertaDescripcion: {
    fontSize: '14px',
    color: '#475569',
    marginBottom: '8px',
  },
  alertaCantidad: {
    fontSize: '13px',
    color: '#64748b',
    margin: 0,
  },
  detalleSection: {
    marginTop: '30px',
  },
};

// --- ESTILOS SOLO PARA IMPRESIÓN ---
const printStyles = `
  @media print {
    /* Ocultar encabezados y pies de página del navegador */
    @page {
      margin: 0;
      size: auto;
    }
    
    /* Ocultar URL, fecha y título de página */
    body {
      margin: 0;
      padding: 15mm;
    }
    
    /* Ocultar todo excepto el área de impresión */
    body * {
      visibility: hidden !important;
    }
    
    #printArea, #printArea * {
      visibility: visible !important;
    }
    
    #printArea {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      background: white !important;
      padding: 20px;
    }
    
    /* Evitar saltos de página en elementos importantes */
    .card, table, .statsGrid {
      page-break-inside: avoid;
    }
    
    /* Asegurar que las tablas no se corten */
    table {
      page-break-inside: auto;
    }
    
    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }
    
    thead {
      display: table-header-group;
    }
    
    tfoot {
      display: table-footer-group;
    }
  }
`;

// Inyectar estilos en el documento
if (typeof document !== "undefined") {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = printStyles;
  document.head.appendChild(styleSheet);
}

export default Reportes;